import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {Currency} from "../../../../types/Currency";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {OfferType} from "../../../types/OfferType";
import {IOfferArchivedData} from "../../../utils/is_offer_archived";
import {IGtmEcommerceOfferAvailabilityParams} from "../common/get_gtm_ecommerce_offer_availability";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {IGetGTMEcommerceSpainParams} from "../common/get_gtm_ecommerce_spain_params";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";

export interface IHitGTMOfferWishlistParams {
    offer: {
        type: OfferType;
        region: IGetGTMEcommerceOfferRegion;
        construction_date_range?: {
            upper?: string;
        };
        currency: Currency;
    } & IGtmEcommerceOfferItemBaseProps &
        IGetGTMEcommerceSpainParams & {
            configuration: IOfferArchivedData["configuration"] & IGtmEcommerceOfferAvailabilityParams["configuration"];
        };
}

// NOTE: Parameters with "na" values are omitted instead of being added - analytics doesn't need these fields
export const hitGTMOfferAddToWishlist = (data: IHitGTMOfferWishlistParams) => {
    const offerData = data.offer;
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(offerData),
        item_category: "investment",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        ...(offerData?.construction_date_range?.upper ? {item_comissioning_date: offerData.construction_date_range.upper} : {}),
        ...getGTMEcommerceOfferRegion(offerData.region)
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "add_to_wishlist",
        ecommerce
    });
};
import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {Currency} from "../../../../types/Currency";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {OfferType} from "../../../types/OfferType";
import {IOfferArchivedData} from "../../../utils/is_offer_archived";
import {IGtmEcommerceOfferAvailabilityParams} from "../common/get_gtm_ecommerce_offer_availability";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {IGetGTMEcommerceSpainParams} from "../common/get_gtm_ecommerce_spain_params";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";

export interface IHitGTMOfferWishlistParams {
    offer: {
        type: OfferType;
        region: IGetGTMEcommerceOfferRegion;
        construction_date_range?: {
            upper?: string;
        };
        currency: Currency;
    } & IGtmEcommerceOfferItemBaseProps &
        IGetGTMEcommerceSpainParams & {
            configuration: IOfferArchivedData["configuration"] & IGtmEcommerceOfferAvailabilityParams["configuration"];
        };
}

// NOTE: Parameters with "na" values are omitted instead of being added - analytics doesn't need these fields
export const hitGTMOfferAddToWishlist = (data: IHitGTMOfferWishlistParams) => {
    const offerData = data.offer;
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(offerData),
        item_category: "investment",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        ...(offerData?.construction_date_range?.upper ? {item_comissioning_date: offerData.construction_date_range.upper} : {}),
        ...getGTMEcommerceOfferRegion(offerData.region)
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "add_to_wishlist",
        ecommerce
    });
};
